import {
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { combineLatest, Observable, Subject } from 'rxjs';
import { EventService } from '@app/event/event.service';
import { map, take, tap } from 'rxjs/operators';
import { WebkitService } from '@app/event/speech-engines/webkit/webkit.service';
import { SpeechService } from '@app/event/speech-engines/speech.service';
import { Page, RoutingService } from '@app/routing.service';
import { UserService } from '@app/user/user.service';
import { AuthService } from '@app/auth/auth.service';
import { untilDestroyed } from 'ngx-take-until-destroy';
// import { User } from '@app/graphql/generated';
import { Apollo } from 'apollo-angular';

interface Nav {
  to?: string;
  text: string;
  selected?: boolean;
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  canGoBack = false;
  focusedElement = '';
  timeout;
  showUserPanel = false;
  @ViewChild('navSlide', { read: ElementRef })
  navSlide: ElementRef;
  @ViewChild('parentUl', { read: ElementRef })
  parentUl: ElementRef;
  @ViewChild('currentUserEl', { read: ElementRef })
  currentUserEl: ElementRef;
  nav: Array<Nav> = null;

  showSidebar: boolean;
  currentPage: Observable<Page>;
  currentUser$: Observable<any>;
  showReturnToStreamButton: Observable<boolean>;
  showResumeEndStreamButtons: Observable<boolean>;
  isCurrentlyStreaming: Observable<boolean>;
  uncompletedEvent: Observable<any>;
  routingService: RoutingService;
  currentUser: any;
  expanded;

  toggleDrawer() {
    this.expanded = !this.expanded;
  }

  constructor(
    private router: Router,
    private eventService: EventService,
    private webkitService: WebkitService,
    private speech: SpeechService,
    routingService: RoutingService,
    private userService: UserService,
    private apollo: Apollo,
    private authService: AuthService
  ) {
    this.routingService = routingService;
  }

  ngOnInit() {
    this.currentPage = this.routingService.currentPage();
    this.currentUser$ = this.userService.currentUser();
    this.userService
      .currentUser()
      .pipe(
        untilDestroyed(this),
        tap((currentUser: any) => (this.currentUser = currentUser)),
        tap(console.log)
      )
      .subscribe();
    this.isCurrentlyStreaming = this.speech.isRecording$;

    this.showReturnToStreamButton = combineLatest([
      this.currentPage,
      this.currentUser$
    ]).pipe(
      map(
        ([page, user]) =>
          !!user.uncompletedEvent &&
          page.e.snapshot.params.eventId !== user.uncompletedEvent.shortId
      )
    );

    this.uncompletedEvent = this.currentUser$.pipe(
      map(user => user.uncompletedEvent)
    );

    this.router.events
      .pipe(
        untilDestroyed(this),
        tap(event => {
          if (event instanceof NavigationStart) {
            this.showUserPanel = false;
          }
        })
      )
      .subscribe();

    this.showResumeEndStreamButtons = combineLatest([
      this.currentPage,
      this.currentUser$,
      this.isCurrentlyStreaming
    ]).pipe(
      map(
        ([page, user, isCurrentlyStreaming]) =>
          page.name === 'EVENT_PAGE' &&
          !isCurrentlyStreaming
      )
    );
  }

  currentUserInitial(): string {
    return this.currentUser ? this.currentUser.firstName[0] : '';
  }

  toggleUserPanel(): void {
    this.showUserPanel = !this.showUserPanel;
  }

  closeUserPanel(): void {
    this.showUserPanel = false;
  }

  onNavItemMouseEnter(e, item) {
    const target: Element = e.target;
    const offsetFromLeft = target.getBoundingClientRect().left;
    const width = target.querySelector('a').clientWidth;
    const liWidth = target.clientWidth;
    this.slideIndicatorToPosition(offsetFromLeft, width, liWidth);
    this.focusedElement = item.text;
  }

  onNavItemMouseLeave(e, item) {
    const target: Element = e.target;
  }

  onNavMouseEnter() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  onNavMouseLeave() {
    this.timeout = setTimeout(() => {
      const target: Element = document.querySelector('.link-active')
        .parentElement;
      this.slideIndicatorToNavItem(target);
    }, 300);
  }

  completeEvent() {
    this.eventService
      .completeEvent()
      .pipe(
        take(1),
        map(() => this.userService.refetchCurrentUser())
      )
      .subscribe();
  }

  startRecording(service: string) {
    this.speech.startRecording(service);
  }

  stopRecording() {
    this.speech.stopRecording();
  }

  slideIndicatorToNavItem(element) {
    const offsetFromLeft = element.getBoundingClientRect().left;
    const width = element.querySelector('a').clientWidth;
    const liWidth = element.clientWidth;
    this.focusedElement = element.querySelector('a').innerText;
    this.slideIndicatorToPosition(offsetFromLeft, width, liWidth);
  }

  slideIndicatorToPosition(x, width, liWidth) {
    const offsetFromLeft = this.parentUl.nativeElement.getBoundingClientRect()
      .left;
    const adjustedX = x - offsetFromLeft;
    const barWidth = width + 32;
    const barWidthInRem = barWidth / 16;
    const barPositionX = adjustedX + (liWidth - barWidth) / 2;
    this.navSlider.style.paddingLeft = barWidthInRem / 2 + 'rem';
    this.navSlider.style.paddingRight = barWidthInRem / 2 + 'rem';
    this.navSlider.style.transform = `translateX(${barPositionX}px)`;
  }

  get navSlider() {
    return this.navSlide.nativeElement;
  }

  logout() {
    this.authService.logout();
  }

  ngOnDestroy(): void {}
}
